import type { MutationHookOptions } from '@apollo/client'
import { MyTrainingRequestsDatatableDocument } from 'generated/resources/datatable.graphql'
import {
  UpdateTrainingRequestDocument,
  UpdateTrainingRequestMutation,
  UpdateTrainingRequestMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  UpdateTrainingRequestMutation,
  UpdateTrainingRequestMutationVariables
>

export const useUpdateTrainingRequest = (options?: Options) => {
  const [updateTrainingRequest, { loading }] = useMutation(UpdateTrainingRequestDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.updateTrainingsTrainingRequest,
  })

  return {
    loading,
    update(variables: UpdateTrainingRequestMutationVariables) {
      return updateTrainingRequest({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [MyTrainingRequestsDatatableDocument],
      })
    },
  }
}
